import {api, apiInternal, ApiListResponse, commonApiWrapper} from "@/services/common-api";
import {ICategoryV2} from "@/app/dashboard/models/EventCategory";

export const getCategories = () => commonApiWrapper<ApiListResponse<ICategoryV2>>(apiInternal.get("/category/all"));

export const getCategoryNames = () => commonApiWrapper<ApiListResponse<ICategoryV2>>(api.get('/category/names', {
    params: {
        offset: 0,
        limit: 100
    }
}));